import { Reducer } from 'redux';
import { update } from '../helpers/immutabilityHelper'
import * as Dtos from '../dtos/Tmd.dtos';

import {
    ACTION_SALUTATIONS_LOAD,
    ACTION_SALUTATIONS_LOAD_BY_ID,
    ACTION_SALUTATIONS_LOAD_FAILURE,
    ACTION_SALUTATIONS_LOAD_SUCCESS,

    ACTION_SALUTATIONS_SAVE,
    ACTION_SALUTATIONS_SAVE_SUCCESS,
    ACTION_SALUTATIONS_SAVE_FAILURE,

    ACTION_SALUTATIONS_CREATE,
    ACTION_SALUTATIONS_CREATE_SUCCESS,
    ACTION_SALUTATIONS_CREATE_FAILURE,

    ACTION_SALUTATIONS_VALIDATE,
    ACTION_SALUTATIONS_VALIDATE_SUCCESS,
    ACTION_SALUTATIONS_VALIDATE_FAILURE,

    ACTION_SALUTATIONS_CLEAR,
    ACTION_SALUTATIONS_FILTER,

    SalutationAction
} from '../actions/salutations';
import { RequestState } from "../enumerations/RequestState";
import { IRequestState, IFormFilter } from "./index";
import { updateFailureIndexToId } from "../helpers/formErrorHelper";

export interface ISalutationState {
    formData: Dtos.Salutation | Dtos.Salutation[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    validationFailures: Dtos.ResponseError[];
    lookups: Dtos.Lookup[];
    loadState: IRequestState;
    saveState: IRequestState;
    updateState: IRequestState;
    createState: IRequestState;
    validateState: IRequestState;
    formFilter: IFormFilter;
    formFilteredData: Dtos.Salutation[];
}

const initialState: ISalutationState = {
    formData: undefined,
    formState: undefined,
    formProperties: undefined,
    validationFailures: undefined,
    lookups: undefined,
    loadState: {
        status: RequestState.None
    } as IRequestState,
    saveState: {
        status: RequestState.None
    } as IRequestState,
    updateState: {
        status: RequestState.None
    } as IRequestState,
    createState: {
        status: RequestState.None
    } as IRequestState,
    validateState: {
        status: RequestState.None
    } as IRequestState,
    formFilter: {
        search: "",
        showInActive: false
    },
    formFilteredData: []
};


function loading(state: ISalutationState, _isLoading: boolean): ISalutationState {
    const newState: ISalutationState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function loadSuccess(state: ISalutationState,
    formData: Dtos.Salutation | Dtos.Salutation[],
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[],
    responseStatus: Dtos.ResponseStatus
): ISalutationState {
    const newState: ISalutationState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        loadState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return filter(newState, state.formFilter);
}

function filter(state: ISalutationState, formFilter: IFormFilter): ISalutationState {

    const salutations: Dtos.Salutation[] | undefined =
        state.formData instanceof Array ?
            state.formData :
            undefined;

    const formFilteredData = salutations ? salutations.filter(p => (p.active == true || formFilter.showInActive) &&
        (formFilter.search == "" || p.value.toLowerCase().indexOf(formFilter.search.toLowerCase()) > -1)) : undefined;

    const newState: ISalutationState = update(state, {
        formFilter: {
            $set: formFilter
        },
        formFilteredData: {
            $set: formFilteredData
        }
    });

    return newState;
}

function loadFailure(state: ISalutationState, responseStatus: Dtos.ResponseStatus): ISalutationState {
    const newState: ISalutationState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus?.errorCode,
                errorMessage: responseStatus?.message,
                errors: responseStatus?.errors
            } as IRequestState
        }
    });

    return newState;
}

function clear(state: ISalutationState, propertiesToClear?: string[]): ISalutationState {

    if (!propertiesToClear) {
        let formFilter = state.formFilter;
        const newState: ISalutationState = update(initialState, {
            formFilter: {
                $set: formFilter
            }
        });
        return newState;
    }

    let stateModifier: any = {};

    propertiesToClear.forEach(propertyToClear => {
        stateModifier[propertyToClear] = { $set: initialState[propertyToClear] }
    });

    const newState = update(state, stateModifier);

    return newState;
}

function saving(state: ISalutationState, _isSaving: boolean): ISalutationState {
    const newState: ISalutationState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function saveSuccess(
    state: ISalutationState,
    formData: Dtos.Salutation | Dtos.Salutation[],
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus
): ISalutationState {
    const newState: ISalutationState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        saveState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return newState;
}

function saveFailure(state: ISalutationState, responseStatus: Dtos.ResponseStatus): ISalutationState {
    const newState: ISalutationState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus?.errorCode,
                errorMessage: responseStatus?.message,
                errors: responseStatus?.errors,
                meta: responseStatus.meta
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, state.formData) : undefined
        }
    });

    return newState;
}

function creating(state: ISalutationState, _isCreating: boolean): ISalutationState {
    const newState: ISalutationState = update(state, {
        createState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function createSuccess(
    state: ISalutationState,
    formData: Dtos.Salutation,
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[]
): ISalutationState {
    const newState: ISalutationState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        createState: {
            $set: {
                status: RequestState.Success
            } as IRequestState
        }
    });

    return newState;
}

function createFailure(state: ISalutationState, responseStatus: Dtos.ResponseStatus): ISalutationState {
    const newState: ISalutationState = update(state, {
        createState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus?.errorCode,
                errorMessage: responseStatus?.message,
                errors: responseStatus?.errors
            } as IRequestState
        }
    });

    return newState;
}

function validating(state: ISalutationState, _isValidating: boolean): ISalutationState {
    const newState: ISalutationState = update(state, {
        validateState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function validateSuccess(
    state: ISalutationState,
    formData: Dtos.Salutation,
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus
): ISalutationState {
    const newState: ISalutationState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        validateState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return newState;
}

function validateFailure(state: ISalutationState, responseStatus: Dtos.ResponseStatus): ISalutationState {
    const newState: ISalutationState = update(state, {
        validateState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus?.errorCode,
                errorMessage: responseStatus?.message,
                errors: responseStatus?.errors,
                meta: responseStatus.meta
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, state.formData) : undefined
        }
    });

    return newState;
}

const SalutationReducer: Reducer<ISalutationState> = (state: ISalutationState = initialState, action: SalutationAction) => {
    switch (action.type) {
        case ACTION_SALUTATIONS_LOAD:
        case ACTION_SALUTATIONS_LOAD_BY_ID:
            return loading(state, true);
        case ACTION_SALUTATIONS_LOAD_SUCCESS:
            return loadSuccess(state, action.formData, action.formState, action.formProperties, action.lookups, action.responseStatus);
        case ACTION_SALUTATIONS_LOAD_FAILURE:
            return loadFailure(state, action.responseStatus);
        case ACTION_SALUTATIONS_CLEAR:
            return clear(state, action.propertiesToClear);
        case ACTION_SALUTATIONS_SAVE:
            return saving(state, true);
        case ACTION_SALUTATIONS_SAVE_SUCCESS:
            return saveSuccess(state, action.formData, action.formState, action.responseStatus);
        case ACTION_SALUTATIONS_SAVE_FAILURE:
            return saveFailure(state, action.responseStatus);
        case ACTION_SALUTATIONS_CREATE:
            return creating(state, true);
        case ACTION_SALUTATIONS_CREATE_SUCCESS:
            return createSuccess(state, action.formData, action.formState, action.formProperties, action.lookups);
        case ACTION_SALUTATIONS_CREATE_FAILURE:
            return createFailure(state, action.responseStatus);
        case ACTION_SALUTATIONS_VALIDATE:
            return validating(state, true);
        case ACTION_SALUTATIONS_VALIDATE_SUCCESS:
            return validateSuccess(state, action.formData, action.formState, action.responseStatus);
        case ACTION_SALUTATIONS_VALIDATE_FAILURE:
            return validateFailure(state, action.responseStatus);
        case ACTION_SALUTATIONS_FILTER:
            return filter(state, action.formFilter);

    }

    return state;
}

export default SalutationReducer;